<template>
  <div id="tourModal" aria-hidden="true" class="modal fade p-0" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <!-- Navigation arrows outside modal content -->
        <img
          alt="left chevron"
          class="prev rotate-180"
          :src="getIcon('chevron-circle-left-solid.svg')"
          @click="$refs.carousel.prev()"
        />
        <img
          alt="chevron circle"
          class="next"
          :src="getIcon('chevron-circle-right-solid.svg')"
          @click="$refs.carousel.next()"
        />

        <div class="modal-body p-0">
          <Carousel ref="carousel" :items-to-show="1" :wrap-around="true">
            <Slide v-for="(card, c) in data" :key="c">
              <div class="row img-body text-left">
                <img :alt="'tour step' + c" :src="getImage(card.img)" />
                <p class="pt-4" style="max-width: 600px; margin: 0 auto" v-html="card.para"></p>
              </div>
            </Slide>
            <template #addons>
              <Pagination />
            </template>
          </Carousel>
          <span class="ml-auto">
            <a
              v-dataanchor
              data-bs-dismiss="modal"
              href="#"
              class="skip-tour"
              tagAction="click"
              tagEvent="link"
              tagSection="how to use the portal?"
              tagText="skip tour"
              tagType="internal link"
            >
              Skip tour
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs } from 'vue';
import { Carousel, Slide, Pagination } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import {
  dataLayerAnchorTag,
  dataLayerButtonTag,
  dataLayerSelectTag,
  dataLayerInputTag,
} from 'data-layer-test-oo-gtm';

export default defineComponent({
  name: 'HowToUsePortal',
  directives: {
    dataanchor: dataLayerAnchorTag,
    databutton: dataLayerButtonTag,
    'data-select': dataLayerSelectTag,
    'data-input': dataLayerInputTag,
  },
  components: { Carousel, Slide, Pagination },
  setup() {
    const state = reactive({
      data: [
        {
          img: 'HowToUseStep1.png',
          para: "<p  class='mb-32'>Click on the <strong>Menu</strong> to navigate to your <strong>Dashboard</strong>, On the Dreamscape Learn AR App you can use the <strong>Menu</strong> to access your <strong>Journal, Field Guide,</strong> and <strong>Scene viewer</strong>.</p>",
        },
        {
          img: 'HowToUseStep2.png',
          para: "<p  class='mb-32'>Use the dial to track your program progress. When your progress bar shows <strong>100%</strong> and status shows <strong>Completed</strong>, you are done with your program. You can always see the next act you need to complete in the <strong>Next Module Section</strong>, next to your progress bar.</p>",
        },
        {
          img: 'HowToUseStep3.png',
          para: "<p  class='mb-32'>If you meet the prerequisites for a module, you will see a <strong>Start/Reserve button</strong> that will allow you to reserve seating in a [Dreamscape Learn Pod] or a open the same experience in the [Dreamscape Learn at home experience]</p>",
        },
        {
          img: 'HowToUseStep4.png',
          para: "<p  class='mb-32'>If you want to quickly schedule time in the [Dreamscape Learn Pods] just enter the date you would like to visit into the <strong>Schedule a Visit</strong> section of your <strong>Dashboard</strong>.</p>",
        },
      ],
    });

    const getImage = (img) => require('@/assets/howToUse/' + img);
    const getIcon = (img) => require('@/assets/icons/' + img);

    return {
      ...toRefs(state),
      getImage,
      getIcon,
    };
  },
});
</script>

<style scoped>
.modal-body {
  background: black;
  position: relative;
}

.modal-content {
  background: black !important;
  position: relative; /* For absolute positioning of arrows */
}

.modal-dialog {
  max-width: 800px;
}
</style>
<style>
/* vue3-carousel pagination styles */
.carousel__pagination {
  padding: 25px 48px !important;
  text-align: start !important;
}
.carousel__pagination-button::after {
  background-color: #666 !important;
}
.carousel__pagination-button--active::after,
.carousel__pagination-button:hover::after {
  background-color: #ffc627 !important;
}

/* Hide default navigation buttons */
.carousel__prev,
.carousel__next {
  display: none !important;
}

/* Ensure carousel viewport takes full width */
.carousel__viewport {
  width: 100%;
  position: relative;
}

/* Ensure carousel track maintains layout */
.carousel__track {
  display: flex;
  align-items: flex-start;
}

/* Ensure slides maintain proper layout */
.carousel__slide {
  width: 100%;
  flex-shrink: 0;
}

/* Ensure images inside carousel maintain size */
#tourModal .img-body img {
  width: 100%;
  height: auto;
  max-width: 600px;
  border: 1px solid #ffc627;
  display: block;
  margin: 0 auto;
}

/* Ensure text content is visible */
#tourModal .img-body p {
  color: white;
}

.skip-tour {
  position: absolute;
  bottom: 25px;
  right: 48px;
  z-index: 3;
}
.prev {
  position: absolute;
  left: -12%;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 10;
}
.next {
  position: absolute;
  right: -12%;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 10;
}
.img-body {
  padding: 60px 70px 0px 70px;
}
@media (max-width: 767px) {
  .img-body {
    padding: 20px 33px 0 33px;
  }
  .prev {
    top: 88%;
    z-index: 2;
    left: 3%;
    border-radius: 20px;
  }
  .next {
    top: 88%;
    bottom: 5%;
    z-index: 2;
    right: 45%;
    border-radius: 20px;
  }
}
</style>
